const buildColumns = (categoryOptions) => ([
  {
    field: 'provider',
    headerName: 'provider',
    description: 'Provider name',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'low_threshold',
    headerName: 'Low (Hours)',
    description: 'Low threshold in hours',
    type: 'number',
    width: 140,
    editable: true,
    align: 'right',
    headerAlign: 'left'
  },
  {
    field: 'med_threshold',
    headerName: 'Medium (Hours)',
    description: 'Medium threshold in hours',
    type: 'number',
    width: 160,
    editable: true,
    align: 'right',
    headerAlign: 'left'
  },
  {
    field: 'high_threshold',
    headerName: 'High (Hours)',
    description: 'High threshold in hours',
    type: 'number',
    width: 140,
    editable: true,
    align: 'right',
    headerAlign: 'left'
  },
  {
    field: 'provider_category_id',
    headerName: 'category *',
    description: 'Provider category (required)',
    type: 'singleSelect',
    valueOptions: categoryOptions,
    width: 200,
    editable: true,
    cellClassName: (params) => (params.value ? '' : 'category-missing'),
    renderCell: (params) => {
      if (params.value) {
        const opt = categoryOptions.find((o) => o.value === params.value);
        return opt ? opt.label : params.value;
      }
      return 'Select category';
    }
  },
  {
    field: 'alias',
    headerName: 'alias',
    description: 'Display alias',
    minWidth: 200,
    flex: 1,
    editable: true
  }
]);

export {buildColumns};
